import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/exchange/det_coupon_top_bg.png';
import _imports_1 from '@/assets/img/exchange/check_circle_ic.png';
import _imports_2 from '@/assets/img/exchange/det_coupon_line_center_bg.png';
const _withScopeId = n => (_pushScopeId("data-v-295e5222"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "exchangeDetail" };
const _hoisted_2 = { class: "detailBox" };
const _hoisted_3 = { class: "detailHeader" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "coupon_top_bg",
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_5 = { class: "exchangeStatus" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "check_circle",
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "statusText font-40 font-w500" }, "兑换成功", -1));
const _hoisted_8 = { class: "font-28 validityPeriod" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "detailCenter" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_2,
        alt: ""
    })
], -1));
const _hoisted_10 = { class: "courseList white-bg p-lr20 p-t24 border-box" };
const _hoisted_11 = { class: "imgBox" };
const _hoisted_12 = { alt: "" };
const _hoisted_13 = {
    key: 0,
    class: "type font-24"
};
const _hoisted_14 = { class: "info flex-1 border-box" };
const _hoisted_15 = { class: "title text-ell2 font-32" };
const _hoisted_16 = { class: "teacher text-overflow font-28" };
const _hoisted_17 = { class: "expert gray-6" };
const _hoisted_18 = { class: "hospital gray-6" };
const _hoisted_19 = {
    key: 0,
    class: "studyInfo gray-6 font-24"
};
const _hoisted_20 = { class: "date text-overflow" };
const _hoisted_21 = { class: "detailBottom white-bg font-28" };
const _hoisted_22 = { class: "flex-between" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "leftText" }, "兑换码：", -1));
const _hoisted_24 = { class: "flex-between bottomItem" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "leftText" }, "兑换时间：", -1));
const _hoisted_26 = { class: "flex-between" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "leftText" }, "兑换人：", -1));
import { hostPath } from '@/public/utils/basePath';
import { useRoute, useRouter } from 'vue-router';
import { exchangeResult } from '@api/exchange';
import { appPort, hiddenAppNavBar, jumpModuleApp } from '@/widget/index';
import Header from '@/components/common/Header.vue';
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const isApp = ref(appPort());
        /* 返回 */
        const backFn = () => {
            router.push({
                name: 'exchangeCode'
            });
        };
        const route = useRoute();
        const router = useRouter();
        const codeData = String(route.params.code);
        const resultData = ref({});
        // 获取数据
        const getData = () => {
            exchangeResult({
                code: codeData
            }).then((res) => {
                if (res.code === 200) {
                    resultData.value = res.data;
                }
            });
        };
        // 跳转到课程详情
        const goDetail = val => {
            if (isApp.value) {
                if (val.courseType == 'OLD_OMO') {
                    // 老训练营
                    jumpModuleApp({
                        dataId: val.courseId,
                        typeId: 'operation_detail'
                    });
                }
                else if (/^(NEW_OMO|TEAM)/.test(val.courseType)) {
                    jumpModuleApp({
                        typeId: 'h5',
                        url: `${hostPath}/learn/courseguide/train/${val.courseId}`
                    });
                }
            }
            else {
                if (val.courseType == 'OLD_OMO') {
                    // 老训练营
                    location.assign(`${hostPath}/training/detail?id=${val.courseId}`);
                }
                else if (/^(NEW_OMO|TEAM)/.test(val.courseType)) {
                    router.push({
                        name: 'courseGuidePage',
                        params: { type: 'train', id: val.courseId }
                    });
                }
            }
        };
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        onMounted(() => {
            getData();
        });
        return (_ctx, _cache) => {
            const _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '兑换详情'
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _hoisted_7,
                            _createElementVNode("p", _hoisted_8, " 有效期至" + _toDisplayString(resultData.value?.endedAt), 1)
                        ])
                    ]),
                    _hoisted_9,
                    _createElementVNode("ul", _hoisted_10, [
                        _createElementVNode("li", {
                            class: "flex",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (goDetail(resultData.value)), ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
                                    [_directive_lazy, resultData.value?.cover]
                                ]),
                                (resultData.value?.courseTypeName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(resultData.value?.courseTypeName), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, _toDisplayString(resultData.value?.courseName), 1),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("span", _hoisted_17, _toDisplayString(resultData.value?.expertNames) + " ", 1),
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(resultData.value?.hospitalNames), 1)
                                ]),
                                (resultData.value?.startedAt)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, _toDisplayString(resultData.value?.startedAt) + "开营 ", 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("span", null, _toDisplayString(_unref(codeData)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("span", null, _toDisplayString(resultData.value?.exchangedDate), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("span", null, _toDisplayString(resultData.value?.exchangerName), 1)
                        ])
                    ])
                ])
            ]));
        };
    }
});
